export default (pass) => {
  let re = /(?=.*\d)(?=.*[a-z]).{6,}/
  return re.test(pass)
}